var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassFormItem",
    {
      staticClass: "panel-create-activity__form-date",
      attrs: {
        label: _vm.localizedTexts.date,
        orientation: "horizontal",
        size: "small"
      }
    },
    [
      _c("CompassDatePicker", {
        staticClass: "input-select-date-activity",
        attrs: {
          value: _vm.dateInput,
          calendarOptions: {
            lang: _vm.uiLang,
            disableWeekDays: _vm.disabledWeekDays
          },
          datePickerClass: "panel-create-activity__datepicker",
          formatDateDisplayed: _vm.formatDateDisplayed,
          writable: ""
        },
        on: { "update:value": _vm.onUpdateDateInput }
      }),
      _vm._v(" "),
      _c("CompassTimePicker", {
        staticClass: "input-time-activity",
        attrs: {
          hourFormat: _vm.hourformat,
          min: _vm.workingTimeStart,
          max: _vm.workingTimeEnd,
          autoScroll: ""
        },
        on: { "update:value": _vm.updateTimeInput },
        model: {
          value: _vm.timeInput,
          callback: function($$v) {
            _vm.timeInput = $$v
          },
          expression: "timeInput"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }